import React from 'react';
import { 
  SignIn, 
  SignUp, 
  SignedIn, 
  SignedOut, 
  UserButton
} from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

/**
 * Login component that handles user authentication using Clerk
 * @param {Object} props Component props
 * @param {string} props.mode - 'sign-in' or 'sign-up' mode
 * @param {string} props.redirectUrl - URL to redirect after successful authentication
 * @returns {React.ReactNode} Login component
 */
const Login = ({ mode = 'sign-in', redirectUrl = '/dashboard' }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {mode === 'sign-in' ? 'Sign in to your account' : 'Create your account'}
          </h2>
        </div>

        <SignedIn>
          {/* If the user is already signed in, redirect to dashboard */}
          <div className="text-center">
            <p className="mb-4">You're already signed in!</p>
            <button
              onClick={() => navigate(redirectUrl)}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Go to Dashboard
            </button>
          </div>
        </SignedIn>

        <SignedOut>
          {/* Show Clerk's sign-in or sign-up UI */}
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            {mode === 'sign-in' ? (
              <SignIn
                routing="path"
                path="/sign-in"
                signUpUrl="/sign-up"
                afterSignInUrl={redirectUrl}
              />
            ) : (
              <SignUp
                routing="path"
                path="/sign-up"
                signInUrl="/sign-in"
                afterSignUpUrl={redirectUrl}
              />
            )}
          </div>
        </SignedOut>
      </div>
    </div>
  );
};

/**
 * LoginButton component that can be used in nav bars and other areas
 * @returns {React.ReactNode} Login button or user menu
 */
export const LoginButton = () => {
  const navigate = useNavigate();
  
  // Import the Button component from common
  const Button = require('../../common/Button').Button;
  
  return (
    <>
      <SignedIn>
        <UserButton afterSignOutUrl="/" />
      </SignedIn>
      <SignedOut>
        <Button
          onClick={() => navigate('/sign-in')}
          variant="solid"
          color="primary"
        >
          Sign In
        </Button>
      </SignedOut>
    </>
  );
};

export default Login;
